import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourOrderEmits = {};
export type TourOrderProps = {};

export default class TourOrderSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourOrder = ref<OrionTour>();

	@Reactive private readonly state = {
		hasData: false,
		canWrite: false,
	};

	get hasData () { return this.state.hasData }
	get canWrite () { return this.state.canWrite }

	constructor (
		private props: TourOrderProps,
		private emits: TourOrderEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();

		this.registerBusEvent('orderListLoaded', hasData => this.state.hasData = hasData);
		this.registerBusEvent('orderPermissionLoaded', canWrite => this.state.canWrite = canWrite);

		useTour('tourOrder', this._tourOrder.value);
	}

	private orderListHeader () {
		return document.querySelector(`.shared-paged-list-order-header`);
	}

	orderListOrderBy () {
		return document.querySelector('.shared-paged-list-order-header');
	}

}
